import { Href } from 'expo-router';

const RouteOverrides = (route: string): Href | null => {
  const lastSlashIndex = route.lastIndexOf('/');
  const prefix = route.slice(0, lastSlashIndex);
  const suffix = route.slice(lastSlashIndex + 1);
  switch (route) {
    case 'https://bank.varomoney.com/move/transfer/new':
      return '/move-money/transfer/transfer-money';
    case 'https://bank.varomoney.com/myvaro/card':
      return '/myvaro/card';
    default:
      switch (prefix) {
        case 'https://bank.varomoney.com/settings/card/change-pin':
          return `/myvaro/card/change-pin/${suffix}`;
        case `https://bank.varomoney.com/transaction/suspicious-txn-review`:
          return {
            pathname: '/suspicious-transaction',
            params: { id: suffix },
          };
        default:
          return null;
      }
  }
};

export default RouteOverrides;
